import { QuoteRequestLine, ProcessStep, MaterialLayout } from "../types";

type Props = {
  processStep: ProcessStep & {
    materialLayout: MaterialLayout | null;
  };
  quoteRequestLineQuantity: QuoteRequestLine["quantity"];
};

export const computeMaterialProcessCost = ({
  processStep,
  quoteRequestLineQuantity,
}: Props): {
  materialCost: number;
  materialMargin: number;
  totalMaterialPrice: number;
} => {
  const { materialLayout, isMaterialLayoutPerPart, margin } = processStep;

  if (!materialLayout) {
    return {
      materialCost: 0,
      materialMargin: 0,
      totalMaterialPrice: 0,
    };
  }

  const { price, quantity } = materialLayout;

  const materialCost =
    price && quantity
      ? price * quantity * (isMaterialLayoutPerPart ? quoteRequestLineQuantity : 1)
      : 0;

  const materialMargin = (materialCost * (margin || 0)) / 100;
  const totalMaterialPrice = materialCost + materialMargin;

  return {
    materialCost,
    materialMargin,
    totalMaterialPrice,
  };
};
